import React from "react"
import { Flex, Link, Heading, Box } from "@chakra-ui/react"
import { Link as GatsbyLink, navigate } from "gatsby"

import {
  ALL_STAR_PAGES_URL,
  SPECIALTIES_LIST,
} from "../../../constants/constants"
import Dropdown from "../../dropdown"
import DropdownMenu from "../../dropdown-menu"
import { useYear } from "../../../context/YearContext"
import { AiOutlineArrowLeft } from "react-icons/ai"

const styles = {
  menu: {
    display: {
      base: "flex",
      md: "flex",
      lg: "flex",
    },
    gap: { base: "10px", md: "12px", lg: "32px" },
    p: { base: "12px 24px" },
    flexDirection: { base: "column", md: "row", lg: "row" },
    justifyContent: "space-between",
    alignItems: { base: "flex-start", md: "center", lg: "center" },
    background: "#ECEFF7",
    fontFamily: "Inter var, sans-serif",
  },
  "menu-list": {
    display: {
      base: "flex",
      md: "flex",
      lg: "flex",
    },
    gap: { base: "16px", md: "24px", lg: "32px" },
    p: { base: "0", md: "0", lg: "12px 24px" },
    flexDirection: { base: "row", md: "row", lg: "row" },
    justifyContent: "space-between",
    alignItems: { base: "center", md: "flex-start", lg: "center" },
  },
  "menu-brand": {
    display: "flex",
    gap: "10px",
    flexDirection: { base: "column", md: "column", lg: "row" },
    alignItems: "center",
    w: { base: "100%", md: "auto", lg: "auto" },
  },
  "menu-dropdown": {
    display: "flex",
    flexDirection: { base: "row", md: "row", lg: "row" },
    justifyContent: "space-between",
    alignItems: { base: "center", md: "flex-start", lg: "center" },
    gap: "12px",
    w: { base: "100%", md: "100%", lg: "auto" },

    "css-r6z5ec": {
      zIndex: "11 !important",
    },
  },
  heading: {
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "40px",
    textAlign: "center",
    letterSpacing: "0em",
  },
  "allstar-text": {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    color: "#129459",
  },
  link: {
    color: "#333333",
    fontSize: "14px",
  },
  activeLink: {
    color: "#129459",
    fontSize: "14px",
    fontWeight: 700,
  },
  button: {
    px: "24px",
    py: "16px",
    height: "52px",
    bg: "#129459",
    borderRadius: "4px",
    color: "#F0F0F0",
    fontSize: "14px",
    lineHeight: "175%",
    outline: "none",
    "&:hover,&:active,&:focus": {
      bg: "#129459",
      outline: "none",
      border: "none",
    },
  },
  "dropdown-menu": {
    "menu-button": {
      ml: "10px",
      fontSize: "14px",
    },
    "menu-list": {
      height: "auto",
    },
  },
  "menu-dropdown-list": {
    w: { base: "100%", md: "auto", lg: "auto" },
  },
  "menu-heading": {
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    w: "100%",

    "& a:nth-of-type(2)": {
      paddingLeft: { base: "0", md: "24px", lg: "24px" },
    },
  },
}

const SubNavigation = props => {
  const { location, isResourceSite } = props

  const { selectedYear, setSelectedYear } = useYear()

  const options = [{ label: "2025" }, { label: "2024" }]

  const url = location?.pathname.split("/")?.[1]

  const handleSelect = selectedOption => {
    setSelectedYear(selectedOption.label)
  }

  const pathName = location.pathname

  const displayIcon =
    isResourceSite ||
    pathName === `/${ALL_STAR_PAGES_URL.HOME}/` ||
    pathName === `/${ALL_STAR_PAGES_URL.FAQ}/` ||
    pathName === `/${ALL_STAR_PAGES_URL.KEY_FINDINGS}/` ||
    pathName === `/${ALL_STAR_PAGES_URL.METHODOLOGY}/`
      ? true
      : false

  const displaySpecialitiesDropdown =
    isResourceSite ||
    pathName === `/${ALL_STAR_PAGES_URL.FAQ}/` ||
    pathName === `/${ALL_STAR_PAGES_URL.KEY_FINDINGS}/` ||
    pathName === `/${ALL_STAR_PAGES_URL.METHODOLOGY}/`
      ? true
      : false

  const handleSpecialtiesSelect = selectedOption => {
    navigate(selectedOption?.path)
  }

  const year = selectedYear === "2024" ? `?year=${selectedYear}` : ""
  return (
    <Flex sx={styles.menu}>
      <Flex sx={styles["menu-brand"]}>
        <Flex sx={styles["menu-heading"]}>
          {!displayIcon && (
            <Link
              href={`/best-surgeons-and-hospitals-research-all-stars/${year}`}
              position="absolute"
              left="0"
            >
              <AiOutlineArrowLeft color={"#129459"} size={20} />
            </Link>
          )}
          <Link
            href={`/best-surgeons-and-hospitals-research-all-stars/${year}`}
            textAlign="center"
          >
            <Heading as="h2" sx={styles["allstar-text"]}>
              Healthcare Research All-Stars
            </Heading>
          </Link>
        </Flex>
        <Flex sx={styles["menu-dropdown"]}>
          <Box sx={styles["menu-dropdown-list"]}>
            <Dropdown
              options={options}
              onSelect={handleSelect}
              location={location}
            />
          </Box>
          {!displaySpecialitiesDropdown && selectedYear === "2025" && (
            <Box sx={styles["menu-dropdown-list"]}>
              <Dropdown
                options={SPECIALTIES_LIST}
                onSelect={handleSpecialtiesSelect}
                location={location}
                isSpecialist
              />
            </Box>
          )}
        </Flex>
      </Flex>
      <Flex sx={styles["menu-list"]}>
        {!isResourceSite ? (
          <>
            <Link
              as={GatsbyLink}
              to={`/${ALL_STAR_PAGES_URL.HOME}/${year}`}
              sx={
                url === ALL_STAR_PAGES_URL.HOME ||
                (url !== ALL_STAR_PAGES_URL.KEY_FINDINGS &&
                  url !== ALL_STAR_PAGES_URL.METHODOLOGY &&
                  url !== ALL_STAR_PAGES_URL.FAQ)
                  ? styles.activeLink
                  : styles.link
              }
            >
              All-Stars
            </Link>
            <Link
              as={GatsbyLink}
              to={`/${ALL_STAR_PAGES_URL.FAQ}/${year}`}
              sx={
                url === ALL_STAR_PAGES_URL.FAQ ? styles.activeLink : styles.link
              }
            >
              FAQ
            </Link>
            <Link
              as={GatsbyLink}
              to={`/${ALL_STAR_PAGES_URL.KEY_FINDINGS}/${year}`}
              sx={
                url === ALL_STAR_PAGES_URL.KEY_FINDINGS
                  ? styles.activeLink
                  : styles.link
              }
            >
              Key Findings
            </Link>
            <Link
              as={GatsbyLink}
              to={`/${ALL_STAR_PAGES_URL.METHODOLOGY}/${year}`}
              sx={
                url === ALL_STAR_PAGES_URL.METHODOLOGY
                  ? styles.activeLink
                  : styles.link
              }
            >
              Methodology
            </Link>
          </>
        ) : (
          // Resource Site Links
          <>
            <Link
              as={GatsbyLink}
              to={`/${ALL_STAR_PAGES_URL.LANDING}/${year}`}
              sx={
                url === ALL_STAR_PAGES_URL.LANDING
                  ? styles.activeLink
                  : styles.link
              }
            >
              Home
            </Link>
            <Link
              as={GatsbyLink}
              to={`/${ALL_STAR_PAGES_URL.PRE_LAUNCH_FAQ}/${year}`}
              sx={
                url === ALL_STAR_PAGES_URL.PRE_LAUNCH_FAQ
                  ? styles.activeLink
                  : styles.link
              }
            >
              FAQ
            </Link>
            <Link
              as={GatsbyLink}
              to={`/${ALL_STAR_PAGES_URL.BADGES}/${year}`}
              sx={
                url === ALL_STAR_PAGES_URL.BADGES
                  ? styles.activeLink
                  : styles.link
              }
            >
              Badges
            </Link>
            <DropdownMenu styles={styles["dropdown-menu"]} title="Templates">
              <Link
                as={GatsbyLink}
                to={`/${ALL_STAR_PAGES_URL.SOCIAL_MEDIA_TEMPLATES}/${year}`}
                sx={
                  url === ALL_STAR_PAGES_URL.SOCIAL_MEDIA_TEMPLATES
                    ? styles.activeLink
                    : styles.link
                }
              >
                Social Media Templates
              </Link>
              <Link
                as={GatsbyLink}
                to={`/${ALL_STAR_PAGES_URL.PRESS_RELEASE_TEMPLATE}/${year}`}
                sx={
                  url === ALL_STAR_PAGES_URL.PRESS_RELEASE_TEMPLATE
                    ? styles.activeLink
                    : styles.link
                }
              >
                Press Release Template
              </Link>
            </DropdownMenu>
            <Link
              as={GatsbyLink}
              to={`/${ALL_STAR_PAGES_URL.PRE_LAUNCH_METHODOLOGY}/${year}`}
              sx={
                url === ALL_STAR_PAGES_URL.PRE_LAUNCH_METHODOLOGY
                  ? styles.activeLink
                  : styles.link
              }
            >
              Methodology
            </Link>
          </>
        )}
      </Flex>
    </Flex>
  )
}

export default SubNavigation
